
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-circular-progressbar/dist/styles.css';
import moment from 'moment';

import CreatePopup from './createWrite';
import { Preloader } from '../preloader';
import ScheduleByDay from './schedule-by-day';
import ScheduleByWeek from './schedule-by-week';
import ScheduleByMonth from './schedule-by-month';
import {
    getFiltersParamsAction,
    changeTimeAction,
    getSettingsAction
} from './actions';
import { setCreatingWriteAction } from './actions';
import './style.scss';

class Schedule extends React.Component {
    componentDidMount() {
        const {
            dispatch,
            schedule
        } = this.props;
        const { filials, services } = schedule;

        dispatch(getSettingsAction());
        if (filials === null && services === null) {
            dispatch(getFiltersParamsAction());
        }

        window.addEventListener('beforeunload', (e) => {
            if (localStorage.getItem('edit_ticket_id')) {
                const id = +localStorage.getItem('edit_ticket_id');
                dispatch(setCreatingWriteAction('UNSET', { id }));
                e.preventDefault();
            }
        });
    }

    componentDidUpdate(prevProps) {
        const { schedule: prevSchedule } = prevProps;
        const { schedule: currentSchedule, dispatch } = this.props;
        if (prevSchedule.data === null && currentSchedule.data) {
            const checkInterval = 1 * 60 * 1000;
            const time = moment();
            const offsetTime = (60 - +time.format('s')) * 1000;

            setTimeout(() => {
                setInterval(() => dispatch(changeTimeAction()), checkInterval);
            }, offsetTime);

            dispatch(changeTimeAction());
        }
    }

    // onSelectDay = (date) => {
    //     const { dispatch, filter } = this.props;
    //     dispatch(getScheduleWSAction({ ...filter, date, typeView: TYPES_VIEW[0] }));
    //     dispatch(switchDateAction(date));
    //     dispatch(switchTypeAction(TYPES_VIEW[0]));
    // }

    render() {
        const {
            filter,
            schedule
        } = this.props;
        const { typeView } = filter;
        const { data: dataSchedule, loading: loadingSchedule } = schedule;

        if (dataSchedule !== null && !loadingSchedule) {
            if (typeView && typeView.value === 'day') {
                return (
                    <>
                        <ScheduleByDay />
                        <CreatePopup />
                    </>
                );
            } if (typeView && typeView.value === 'week') {
                return (
                    <>
                        <ScheduleByWeek />
                        <CreatePopup />
                    </>
                );
            } if (typeView && typeView.value === 'month') {
                return (
                    <>
                        <ScheduleByMonth />
                        <CreatePopup />
                    </>
                );
            }

            return null;
        }

        return <Preloader />;
    }
}

Schedule.propTypes = {
    dispatch: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    filter: state.filter,
    schedule: state.schedule
});

export default connect(mapStateToProps)(Schedule);
